import { Shield, Truck, Award, CreditCard, Headphones, RefreshCw, Package, Clock } from 'lucide-react';

const TrustBadges = () => {
  const badges = [
    { icon: Award, label: 'Trusted Since 2020', subLabel: 'Quality Guaranteed' },
    { icon: Shield, label: 'Genuine Products', subLabel: '100% Authentic' },
    { icon: CreditCard, label: 'Secure Payments', subLabel: 'Stripe Checkout' },
    { icon: Truck, label: 'Fast Delivery', subLabel: '3-7 Days' },
    { icon: RefreshCw, label: 'Easy Returns', subLabel: '7 Day Policy' },
    { icon: Headphones, label: 'Customer Support', subLabel: 'WhatsApp Help' },
    { icon: Package, label: 'Safe Packaging', subLabel: 'Damage Protection' },
    { icon: Clock, label: 'Express Shipping', subLabel: 'Dubai to India' },
  ];

  return (
    <div className="bg-white border-y border-slate-100 py-2 sm:py-3 overflow-hidden">
      <div className="flex animate-scroll-x">
        {/* Duplicate badges for seamless loop */}
        {[...badges, ...badges].map((badge, index) => (
          <div
            key={`badge-${index}-${badge.label}`}
            className="flex items-center gap-2 sm:gap-3 px-3 sm:px-6 min-w-max border-r border-slate-100 last:border-0"
          >
            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-slate-50 flex items-center justify-center flex-shrink-0">
              <badge.icon className="w-4 h-4 sm:w-5 sm:h-5 text-[#0047AB]" />
            </div>
            <div>
              <p className="text-xs sm:text-sm font-semibold text-slate-900 whitespace-nowrap">
                {badge.label}
              </p>
              <p className="text-[10px] sm:text-xs text-slate-500 whitespace-nowrap">
                {badge.subLabel}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustBadges;
